import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Logo } from '../../assets/icons/logo.svg';
import { ReactComponent as EmailIcon } from '../../assets/icons/email.svg';
import { ReactComponent as NotificationIcon } from '../../assets/icons/notification.svg';
import avatar from '../../assets/icons/avatar.png';
import { Menu, MenuItem } from '@reach/menu-button';
import React from 'react';

export const Header = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <div className="header">
      <div className="left-side-links">
        <Link to="/" className="header-logo">
          <Logo />
        </Link>
        {menus.map((menu: Menu): JSX.Element => {
          return (
            <Menu key={menu.title}>
              <MenuItem key={menu.title} onSelect={(): void => navigate(menu.url)}>
                {menu.title}
              </MenuItem>
            </Menu>
          );
        })}
      </div>
      <div className="right-side-links">
        <button className="upload-btn">+ Upload</button>
        <span className="email-btn">
          <EmailIcon />
        </span>
        <span className="bell-btn">
          <NotificationIcon />
        </span>
        <span className="avatar-btn">
          <img src={avatar} />
        </span>
      </div>
    </div>
  );
};

type Menu = {
  title: string;
  url: string;
};

const menus: Menu[] = [
  {
    title: 'Discover',
    url: '/discover',
  },
  {
    title: 'NFT\'s',
    url: '/nfts',
  },
];
